import { render, staticRenderFns } from "./SelectReference.vue?vue&type=template&id=3b90e484&"
import script from "./SelectReference.vue?vue&type=script&lang=ts&"
export * from "./SelectReference.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports